export interface IReminder {
  name?: string
  email: string
  when: ReminderOptions
}

export interface IReminderRequest {
  Name?: string
  Email: string
  RemindMeIn: ReminderOptions
}

export enum ReminderOptions {
  Now = "0",
  OneDay = "1",
  OneWeek = "7",
}
